<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasTopContent]="true"
  [hasCommonHeader]="false"
  [hasCustomHeader]="true"
>
  <ng-container customHeader>
    <my-bill-back-button
      [backButtonType]="'leftArrowPlainText'"
    ></my-bill-back-button>
    <h1 class="rs-txt-c2">
      {{ 'bills.options.infoPage.title' | translate }}
    </h1>
  </ng-container>
  <ng-container topContent>
    <div class="rs-panel-big rs-bg-c2 rs-box-shadow">
      <div class="row">
        <div class="columns small-12 medium-6">
          <h2 class="rs-tit6 rs-txt-c1">
            {{ 'bills.options.infoPage.subtitle' | translate }}
          </h2>
          <p class="rs-txt-details">
            {{ 'bills.options.infoPage.contentExplanation' | translate }}
          </p>
          <div class="rs-me"></div>
          <my-bill-deferral-rules-list></my-bill-deferral-rules-list>
        </div>
        <div class="small-12 medium-6 columns">
          <my-bill-deferral-card
            *ngIf="billDocument && customerPaymentProfile"
            [customerPaymentProfile]="customerPaymentProfile"
            [partialDeferralCheck]="billDocument.partialDeferralCheck"
            [dueDate]="billDocument.dueDate"
            [deferralDate]="billDocument.deferralDate"
          >
          </my-bill-deferral-card>
        </div>
      </div>
    </div>
  </ng-container>
</my-bill-odb-page-base-structure>
